import React from 'react';
import { Card } from '../../components/ui/card';
import { Star } from 'lucide-react';
import BikerLayout from '../../components/biker/BikerLayout';

const BikerReviews = () => {
  return (
    <BikerLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Reviews</h1>
          <p className="text-gray-600 mt-1">See what customers say about you</p>
        </div>

        <Card className="p-12 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
            <Star className="h-8 w-8 text-gray-400" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">No Reviews Yet</h2>
          <p className="text-gray-600">
            Customer reviews will appear here once you complete deliveries.
          </p>
        </Card>
      </div>
    </BikerLayout>
  );
};

export default BikerReviews;
